module.exports = __webpack_public_path__ + "static/media/Rti_logo.3c23d276.png";